<template>
    <div class="accessibility-container">
        <button class="trigger" @click="toggleMenu"></button>
        <div class="accessibility-menu-container" :class="{'is-open': isActive}">
            <div class="accessibility-menu">
                <div class="font-picker">
                    <div class="label">{{ lang.fontSize }}:</div>
                    <div class="options">
                        <button
                            class="text-xs"
                            :class="{'is-selected': settings.fontSize == 'small'}"
                            @click="selectFontSize('small')"
                        >A</button>
                        <button
                            class="text-base"
                            :class="{'is-selected': settings.fontSize == 'base'}"
                            @click="selectFontSize('base')"
                        >A</button>
                        <button
                            class="text-xl"
                            :class="{'is-selected': settings.fontSize == 'large'}"
                            @click="selectFontSize('large')"
                        >A</button>
                        <button
                            class="text-2xl"
                            :class="{'is-selected': settings.fontSize == 'extra-large'}"
                            @click="selectFontSize('extra-large')"
                        >A</button>
                    </div>
                </div>

                <div class="dislexy-picker">
                    <div class="switch">
                        <input id="dislexy" type="checkbox" v-model="settings.dislexy" />
                        <label for="dislexy" class="label">
                            {{ lang.dislexy }}:
                            <span class="_switch-control"></span>
                        </label>
                    </div>
                </div>

                <div class="contrast-picker">
                    <div class="switch">
                        <input id="contrast" type="checkbox" v-model="settings.contrast" />
                        <label for="contrast" class="label">
                            {{ lang.contrast }}:
                            <span class="_switch-control"></span>
                        </label>
                    </div>
                </div>

                <button class="btn-reset" @click="resetSettings">{{ lang.reset }}</button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Accessibility",

    props: ['lang', 'cookieEnabled'],

    data() {
        return {
            isActive: false,
            settings: {
                fontSize: "base",
                dislexy: false,
                contrast: false,
            },
        };
    },

    created() {
        let settings = this.getCookie("accessibility_settings");

        if (settings) {
            this.settings = JSON.parse(settings);
        }

        this.setCookieAlias = this.setCookie;
    },

    watch: {
        "settings.dislexy": function (data, old) {
            let app = document.getElementById("app");

            if (data) {
                app.classList.add("has-dislexy");
            } else {
                app.classList.remove("has-dislexy");
            }

            if (this.cookieEnabled) {
                this.setCookieAlias(
                    "accessibility_settings",
                    JSON.stringify(this.settings),
                    30
                );
            }
        },

        "settings.contrast": function (data, old) {
            let app = document.getElementById("app");

            if (data) {
                app.classList.add("has-contrast");
            } else {
                app.classList.remove("has-contrast");
            }

            if (this.cookieEnabled) {
                this.setCookieAlias(
                    "accessibility_settings",
                    JSON.stringify(this.settings),
                    30
                );
            }
        },

        "settings.fontSize": function (data, old) {
            let app = document.querySelector("html");

            if (data == "base") {
                app.classList.remove("text-x0");
                app.classList.remove("text-x2");
                app.classList.remove("text-x3");
            } else if (data == "small") {
                app.classList.add("text-x0");
                app.classList.remove("text-x2");
                app.classList.remove("text-x3");
            } else if (data == "large") {
                app.classList.remove("text-x0");
                app.classList.remove("text-x3");
                app.classList.add("text-x2");
            } else if (data == "extra-large") {
                app.classList.remove("text-x0");
                app.classList.remove("text-x2");
                app.classList.add("text-x3");
            }

            if (this.cookieEnabled) {
                this.setCookieAlias(
                    "accessibility_settings",
                    JSON.stringify(this.settings),
                    30
                );
            }
        },
    },

    methods: {
        toggleMenu() {
            this.isActive = !this.isActive;
        },

        selectFontSize(size) {
            this.settings.fontSize = size;
        },

        resetSettings() {
            this.settings = {
                fontSize: "base",
                dislexy: false,
                contrast: false,
            };
        },

        setCookie(name, value, durationDays) {
            var d = new Date();
            d.setTime(d.getTime() + durationDays * 24 * 60 * 60 * 1000);
            var expires = "expires=" + d.toUTCString();
            document.cookie = name + "=" + value + ";" + expires + ";path=/";
        },

        getCookie(cookie) {
            var name = cookie + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(";");

            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];

                while (c.charAt(0) == " ") {
                    c = c.substring(1);
                }

                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }

            return "";
        },
    },
};
</script>
